import http from '../lib/http-common';
import authGuestHeader from "./authGuestHeader";

let API_URL = process.env.REACT_APP_BACKEND_URL + '/api/guest/';

const login = ({ formData }) => {
    return http.post(API_URL + "login", formData)
                .then((response) => {
                    if(response.data.accessToken) {
                        localStorage.setItem("token-guest", JSON.stringify(response.data.accessToken));
                    }

                    return response.data;
                })
}

const logout = () => {
    return http.get(API_URL + "logout", { headers: authGuestHeader() })
                .then((response) => {
                    if(response.data.success) {
                        localStorage.removeItem("token-guest")
                        window.location.reload();
                    }
                })

}

const sendResetLinkEmail = ({ formData }) => {
    return http.post(API_URL + "password/email", formData)
}

const resetPassword = ({ formData }) => {
    return http.post(API_URL + "password/reset", formData)
}

const getGuest = () => {
    return http.get(API_URL + 'profile', { headers: authGuestHeader() })
}

const authGuestService = {
    login,
    logout,
    sendResetLinkEmail,
    resetPassword,
    getGuest
};

export default authGuestService;